import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, KeyRound, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            await api.post("/auth/password-reset/request", { email: email.trim().toLowerCase() });
            setDone(true);
        } catch (e2) {
            setErr(formatApiError(e2) || "Error al procesar la solicitud");
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen bg-slate-950 text-slate-50 flex items-center justify-center p-6" data-testid="forgot-password-page">
            <div className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-900/80 p-6 space-y-4">
                <div className="flex items-center gap-2">
                    <KeyRound size={20} className="text-brand-orange"/>
                    <h1 className="font-display text-xl font-bold">Recuperar contraseña</h1>
                </div>
                {done ? (
                    <div className="rounded-lg bg-emerald-500/10 border border-emerald-500/40 p-4 text-sm text-emerald-100" data-testid="forgot-password-success">
                        <CheckCircle2 size={20} className="inline mr-2 text-emerald-300"/>
                        Solicitud registrada. Contacta a un superadmin para obtener tu enlace de recuperación.
                    </div>
                ) : (
                    <form onSubmit={submit} noValidate className="space-y-3">
                        <p className="text-sm text-slate-400">
                            Ingresa tu correo. Un superadmin te compartirá un enlace de recuperación cuando esté disponible.
                        </p>
                        <div>
                            <label className="block text-[10px] uppercase tracking-wider text-slate-400 mb-1">Correo</label>
                            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                                data-testid="forgot-email-input"
                                className="w-full h-11 rounded-lg bg-slate-950 border border-slate-700 text-slate-100 px-3"
                                placeholder="tu@empresa.mx"/>
                        </div>
                        {err && <div className="rounded-lg bg-red-500/10 border border-red-500/40 p-3 text-xs text-red-200" data-testid="forgot-error">{err}</div>}
                        <button type="submit" disabled={busy} data-testid="forgot-submit"
                            className="w-full h-11 rounded-lg bg-brand-orange text-slate-950 font-semibold text-sm inline-flex items-center justify-center gap-2 disabled:opacity-60">
                            {busy && <Loader2 className="animate-spin" size={14}/>}
                            Solicitar
                        </button>
                    </form>
                )}
                <Link to="/login" data-testid="forgot-back-link" className="text-xs text-slate-400 hover:text-brand-orange inline-flex items-center gap-1">
                    <ArrowLeft size={12}/> Volver a iniciar sesión
                </Link>
            </div>
        </div>
    );
}
